export default "https://assets-v2.scaler.com/packs/files/mi-powerbank.fd5e1c.webp";